module.exports = __webpack_public_path__ + "img/precs2.171fbbcf.png";